import React, { useState, useEffect } from 'react'
import { Row, Col, Button } from 'react-bootstrap';
import {  useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { useGetTeacherNewQuestionsQuery } from '../../slices/teachers/teacherQuestionsApiSlice';
import TeacherHeader from '../../components/TeacherHeader';
import TeacherNavbar from '../../components/TeacherNavbar';
import NewQuestion from '../../components/NewQuestion';
import NewQuestion2 from '../../components/NewQuestion2';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import NoQuestions2 from '../../components/NoQuestions2';
import Paginate from '../../components/Paginate';
import { colors13 } from '../../colorConstant';

const TeacherNewQuestions2 = () => {

    const { pageNumber } = useParams();
    
    const navigate = useNavigate();

    const colors2 = [];
    const colors4 = [];
    const colors5 = [];

    const [firstHalf, setFirstHalf] = useState([]);

    const { teacherInfo } = useSelector((state) => state.authTeacher);

    const { data, isLoading, error } = useGetTeacherNewQuestionsQuery({pageNumber});

    useEffect(() => {
        if(!teacherInfo) {
            navigate('/teacherlogin')
        }
    }, [navigate, teacherInfo])

    const pushRandomlyFromColors3ToColors2 = (colors3, colors4) => {
        const usedIndices = new Set();
        while (usedIndices.size < colors3.length) {
          const randomIndex = Math.floor(Math.random() * colors3.length);    
          if (!usedIndices.has(randomIndex)) {
            colors4.push(colors3[randomIndex]);
            usedIndices.add(randomIndex);
          }
        }
      };
      pushRandomlyFromColors3ToColors2(colors13,  colors4,);

    useEffect(() => {
        if(data) {
            setFirstHalf(data?.newquestions);
        }
    }, [navigate, data])
    
    return (
        <div>
        <TeacherNavbar />
            <div className="main-content" id="panel">
            <TeacherHeader /><br /><br /><br />      
                <div className="container-fluid mt--6">
                    {isLoading ? ( 
                        <Loader />
                    ) : error ? (
                        <Message variant='danger'>
                            {error?.data?.message || error.error}
                        </Message>
                    ) : (
                        <div className="row">
                            <h5 className="centerTitle tittleColor4 qFstudents2">
                                <span className='tittleColor4 qFstudents'>
                                 {data?.count} New Questions From Students
                                </span>
                            </h5><br /><br />
                            <div className="offset-xl-1 col-xl-10  ">   
                            <div className="newqBody">
                                <div className=" col-xl-12 ">   
                                    <div className="card timeline23">                
                                        <div className="card-body timeDown"><br />
                                            <div className="timeline22 item-container" data-timeline-content="axis" data-timeline-axis-style="dotted">  
                                                {firstHalf?.map((question, index) => (                        
                                                    <div className='timeline-block timeP2 item' key={question._id} >  
                                                        <NewQuestion2  question={question} color={colors13[index]}  />                    
                                                    </div>
                                                ))}     
                                                {firstHalf?.length === 0 && (
                                                    <div  className="col-xl-5 ">  
                                                        <NoQuestions2 />
                                                    </div>
                                                )}                               
                                            </div>                                            
                                        </div>
                                        <Paginate
                                                pages={data.pages}
                                                page={data.page}
                                                link='teachernewquestions'
                                                className='pagCenter'                                                
                                            />
                                    </div>
                                </div>
                            </div>   
                            </div>                              
                        </div>
                    )} 
                </div>
            </div>
        </div>
    )
}

export default TeacherNewQuestions2